import React from 'react'

const AuthLayout: React.FC = (props) => {
  return <div className="auth-layout">{props.children}</div>
}

export default AuthLayout
